// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/lib/clipboard.ts
// 🔧 PURPOSE: Copiare un testo (codici partner, gift card, link): prima
//   stava in PartnerCard, ora lo usano anche le gift card e "Installa l'app".
// ============================================

/** Copia con l'API degli appunti; senza (http, browser vecchi) con il vecchio execCommand. */
function legacyCopy(text: string): boolean {
  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '0';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}

export function copyText(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    return navigator.clipboard.writeText(text).then(
      () => true,
      () => legacyCopy(text),
    );
  }
  return Promise.resolve(legacyCopy(text));
}
